import {
  ACCOMPLISHMENT,
  AFFILIATION,
  CERTIFICATION,
  SKILL,
  SUMMARY,
  WORK_EXPERIENCE,
} from '@glass/common/modules/content/deprecatedContentTypes';

const resourceTitles = {
  [ACCOMPLISHMENT]: {
    title: 'Accomplishments',
  },
  [AFFILIATION]: {
    title: 'Affiliations',
  },
  [CERTIFICATION]: {
    title: 'Certifications',
  },
  [SKILL]: {
    title: 'Skills',
  },
  [SUMMARY]: {
    title: 'Summaries',
  },
  [WORK_EXPERIENCE]: {
    title: 'Work Experiences',
  },
};

export default resourceTitles;
